import { render, staticRenderFns } from "./CredentialDetail.vue?vue&type=template&id=8f195798&scoped=true"
import script from "./CredentialDetail.vue?vue&type=script&lang=js"
export * from "./CredentialDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f195798",
  null
  
)

export default component.exports